import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useEntities } from '~/react-query-hooks/entities/useEntities';
import { useCompanyThemeCompetitors } from '~/react-query-hooks/knowledge-graph/useKnowledgeGraph';

import * as Shared from '../../ThemeExposureTab.styles';
import { CompetitorCard } from '../competitor-card/CompetitorCard';

export const CompetitorsSection = ({
  entityTag,
  themeId,
  themeName,
}: {
  entityTag: string;
  themeId: string;
  themeName: string;
}) => {
  const { t } = useTranslation(['widget']);

  const { data, isError, isFetching, error } = useCompanyThemeCompetitors({
    entityTag,
    themeId,
    limit: 3,
  });
  const competitors = data?.competitors ?? [];

  const {
    data: entitiesData,
    isError: isEntitiesError,
    isLoading: isEntitiesLoading,
  } = useEntities({
    entityTags: competitors,
    enabled: !!competitors.length,
  });

  const getContent = () => {
    if (isFetching || isEntitiesLoading) {
      return (
        <SkeletonLoader
          areas={Shared.loadingSkeletonAreas}
          data-testid="loading-skeleton"
        />
      );
    } else if (isError || isEntitiesError || !entitiesData.length) {
      return null;
    } else {
      return (
        <Shared.CompetitorsWrapper data-testid="competitors-wrapper">
          {entitiesData.map(entity => (
            <CompetitorCard entity={entity} key={entity.tag} />
          ))}
        </Shared.CompetitorsWrapper>
      );
    }
  };

  if ((!isFetching && !isError && !competitors.length) || error) {
    return null;
  }

  return (
    <Shared.SectionRow>
      <Shared.TitleBase>
        {t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.topCompetitors',
          {
            count: competitors.length,
            name: themeName,
          }
        )}
      </Shared.TitleBase>
      {getContent()}
    </Shared.SectionRow>
  );
};
